export default {
    url: '/submission-finished?guid',
    template: '<quiz-finished form-submission="vm.formSubmission"/>',
    resolve: {
        formSubmission (FormSubmissionResource, $stateParams) {
            return FormSubmissionResource.get({ guid: $stateParams.guid, expand: 'form' }).$promise;
        },
        company (CompanyResource, formSubmission) {
            return CompanyResource.publicView({ id: formSubmission.companyId }).$promise;
        }
    },
    controller (formSubmission, company, CompanyService) {
        if (company.skin) {
            CompanyService.loadSkin(company.skin);
        }

        this.formSubmission = formSubmission;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/submissionfinished/index.js